<!-- copied from the old EasyDrive site: https://easydrive.vw.co.za/app/easydrive/ -->
<section class="page-hero">
    <!-- Model Images -->
    <div class="model-image web-img" style="background-image:url(assets/images/vwsa-header-img.jpg)"></div>
    <div class="model-image mobi-img" style="background-image:url(assets/images/vwsa-header-mobi.jpg)"></div>
    <div class="model-image mobi-ls-img" style="background-image:url(assets/images/vwsa-iPad-Mini-Header.jpg)"></div>
    <!-- Textbox -->
    <div class="main-textbox">
        <div class="text-left">
            <app-vwsa-text text="Get Covered." tag="h1" appearance="headline400" weight="bold" className="headerText">
            </app-vwsa-text><br />
            <app-vwsa-text text="Stay Covered." tag="h1" appearance="headline400" weight="normal" className="headerText"></app-vwsa-text>
        </div>
        <div class="animated-line motion">
            <div class="line lightblue">
            </div>
        </div>
        <div class="right-side">
            <div class="logo">
                <img src="assets/images/VW_Logo_White.png" alt="VW Logo">
            </div>
            <div class="text">
                <app-vwsa-text text="EasyDrive" tag="h1" appearance="headline400" weight="bold" className="headerText">
                </app-vwsa-text>
                <app-vwsa-text text="Vehicle Plans" tag="h1" appearance="headline400" weight="normal" className="headerText"></app-vwsa-text>
            </div>
        </div>
    </div>
</section>